import http from '../config'
const store = {
  hot_keywords() {
    return http({
      url: 'store/product/hot_keywords'
    })
  },
  productCate() {
    return http({
      url: 'store/product/cate'
    })
  },
  addBrowse(id) {
    return http({
      url: `store/products/${id}/browse`,
      method: 'post'
    })
  },
  syncBrowse(data) {
    return http({
      url: 'store/product/browse_import',
      data,
      method: 'post'
    })
  },

  reserve(data) {
    return http({
      url: 'store/order_reservation/reserve',
      method: 'post',
      data
    })
  },
  createOrder(data) {
    return http({
      url: 'store/orders',
      data,
      method: 'post'
    })
  },
  collectProduct(data) {
    return http({
      url: 'store/product/collect',
      method: 'post',
      data
    })
  },
  drug_collectProduct(params) {
    console.log(params, 'params')
    return http({
      url: 'drug/product/collect',
      params
    })
  },
  drug_category() {
    return http({
      url: 'drug/category/suggest'
    })
  },
  drug_all_category() {
    return http({
      url: 'drug/categories'
    })
  },
  products({ params, id }) {
    const url = id ? `store/products/${id}` : 'store/products'
    return http({
      url,
      params
    })
  },
  drug_products({ params, id }) {
    console.log(params)
    const url = id ? `drug/products/${id}` : 'drug/products'
    return http({
      url,
      params
    })
  },
  categoryProduct(id) {
    console.log(id)
    const url = `drug/operations/${id}/products`
    return http({
      url
    })
  },
  orderInvoice(data) {
    return http({
      url: 'store/order_invoices',
      data,
      method: 'post'
    })
  },
  stores({ id }) {
    return http({
      url: `store/stores/${id}`
    })
  },
  shopping_carts(data) {
    return http({
      url: 'store/shopping_carts',
      data,
      method: 'post'
    })
  },
  drug_shopping_carts(data) {
    return http({
      url: 'drug/carts',
      data,
      method: 'post'
    })
  },
  home_layout(params) {
    return http({
      url: 'store/home_layout',
      params
    })
  },
  home_product(params) {
    return http({
      url: 'store/home_product',
      params
    })
  },
  sub_orders(order_no) {
    return http({
      url: `store/sub_orders/${order_no}`
    })
  },
  orderReceived(data) {
    return http({
      url: 'store/order_delivery/receive',
      method: 'post',
      data
    })
  },
  drug_order(data) {
    return http({
      url: 'drug/orders',
      method: 'post',
      data
    })
  },
  drug_order_list({ params }) {
    return http({
      url: 'drug/orders',
      params
    })
  },
  drug_order_detail({ params, id }) {
    const url = id ? `drug/orders/${id}` : 'drug/orders'
    return http({
      url,
      params
    })
  },
  drug_orders(data) {
    return http({
      url: 'drug/cart/purchase',
      method: 'post',
      data
    })
  },
  orderRefund(data) {
    return http({
      url: 'store/sub_order/ask_refund',
      data,
      method: 'post'
    })
  },
  cancelRefund(data) {
    return http({
      url: 'store/sub_order/cancel_refund',
      data,
      method: 'post'
    })
  },
  category(params) {
    return http({
      url: 'store/suggests',
      params
    })
  },
  productClick(data) {
    return http({
      url: 'drug/product/click',
      method: 'post',
      data
    })
  },
  drugOperations(params) {
    return http({
      url: 'drug/operations',
      params
    })
  },
  // 查询商品是否支持使用积分
  checkPointAvailable(params) {
    return http({
      url: 'store/product/check_score_available',
      params
    })
  }
}
export default store
